module.exports = __webpack_public_path__ + "img/热销商品2.d15be0fb.png";